import { Directive, Input, ElementRef, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appTruncate]'
})
export class TruncateDirective implements OnInit {
    @Input('appTruncate') maxLength: number = 16;
    @Input() appTruncateText: string| undefined  = '';

    constructor(private el: ElementRef, private renderer: Renderer2) {}

    ngOnInit(): void {
        let text = this.appTruncateText || this.el.nativeElement.innerText;
        if (text && text.length > this.maxLength) {
            const truncated = text.slice(0, this.maxLength) + '...';
            this.renderer.setProperty(this.el.nativeElement, 'innerText', truncated);
            this.renderer.setAttribute(this.el.nativeElement, 'title', text);
        } else {
            this.renderer.setProperty(this.el.nativeElement, 'innerText', text);
            this.renderer.setAttribute(this.el.nativeElement, 'title', text);
        }
    }
}
